import React from 'react';
import { Box, Loading, PageHeader } from '@ui';
import useTranslation from '@app/hooks/use-translation';
import { useGetAnalyticProjectsForLastProjectsQuery } from '@app/store/api/analytics-projects.api';
import { useGetChatAnalyticProjectsForLastProjectsQuery } from '@app/store/api/chat-api/chat-analytic.api';

import { MainSettingsForm } from './blocks/main-settings';

const QmManageMonitoringFormsCreatePage = () => {
  const { t } = useTranslation('pages.qmManage.monitoring_forms.createMonitoringForm');
  const { data: analyticsProjectsVoice, isLoading: voiceApProjectsLoading } =
    useGetAnalyticProjectsForLastProjectsQuery();
  const { data: analyticsProjectsChat, isLoading: chatApProjectsLoading } =
    useGetChatAnalyticProjectsForLastProjectsQuery();

  const apLoading = chatApProjectsLoading || voiceApProjectsLoading;

  const analyticsProjects = [...(analyticsProjectsChat || []), ...(analyticsProjectsVoice || [])];
  if (apLoading) return <Loading />;
  return (
    <div>
      <PageHeader popLink={`./..`} label={t('create_new_monitoring_form')} />
      <Box className="mt-[42px] p-[45px_0px_0px_75px]">
        <MainSettingsForm newProject={true} analyticsProjects={analyticsProjects} />
      </Box>
    </div>
  );
};

export default QmManageMonitoringFormsCreatePage;
